/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CsvHeaderMapping model module.
* @module model/CsvHeaderMapping
* @version 2020-12-7
*/
export default class CsvHeaderMapping {
    /**
    * Constructs a new <code>CsvHeaderMapping</code>.
    * CSVのヘッダーとカラムの対応
    * @alias module:model/CsvHeaderMapping
    * @class
    * @param target {String} 登録先の項目
    * @param sources {String} 登録元のカラム名
    */

    constructor(target, sources) {
        
        
        this['target'] = target;
        this['sources'] = sources;
        
    }

    /**
    * Constructs a <code>CsvHeaderMapping</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CsvHeaderMapping} obj Optional instance to populate.
    * @return {module:model/CsvHeaderMapping} The populated <code>CsvHeaderMapping</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CsvHeaderMapping();
                        
            
            if (data.hasOwnProperty('target')) {
                obj['target'] = ApiClient.convertToType(data['target'], 'String');
            }
            if (data.hasOwnProperty('sources')) {
                obj['sources'] = ApiClient.convertToType(data['sources'], 'String');
            }
        }
        return obj;
    }

    /**
    * 登録先の項目
    * @member {String} target
    */
    'target' = undefined;
    /**
    * 登録元のカラム名
    * @member {String} sources
    */
    'sources' = undefined;




}
